import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import agencyApi from "api/agencyApi";

export const getAgencyTrackingLogList = createAsyncThunk(
  "AgencyTrackingLog",
  async (params: any = {}) => {
    try {
      const response = await agencyApi.agencyEventStrackingLogs(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
